import { Component, Input, NgZone, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { map } from 'rxjs/operators';
import { NuveiInfo, OnboardingService } from '../../services/onboarding.service';
import { UtilsService } from 'projects/common/src/public-api';
import { Router } from "@angular/router";
import { ModalBehavior, ModalsService } from "../../../../../common/src/lib/services/modals.service";
import {
  ConfirmationDialog
} from "../../../../../common/src/lib/modals/confirmation-dialog/confirmation-dialog.component";
import { BannerComponent } from "./banner.component";
import { SettingsHighlightCourseKey, SettingsTabKey } from "../../pages/profile/profile.component";

@Component({
  selector: 'app-onboarding-banner',
  templateUrl: './onboarding-banner.component.html',
  styleUrls: ['./onboarding-banner.component.scss']
})
export class OnboardingBannerComponent implements OnChanges {

  @Input() bannerData!: NuveiInfo;

  protected nuveiStatusMessage!: string;
  protected nuveiBannerType: BannerComponent['type'];
  protected _expandable = false;
  _expanded = false;

  get expandable() {
    return this._expandable;
  }
  get isExpanded() {
    return this._expanded;
  }

  smallScreen$ = this.utilsService.onScreenBreakpointChange('md').pipe(
      map(large => !large)
  );

  constructor(
    private onboardingService: OnboardingService,
    private utilsService: UtilsService,
    private modalsService: ModalsService,
    private zone: NgZone,
    private router: Router
  ) {}

  expand() {
    this.zone.run(() => {
      this._expanded = true;
    });
  }

  collapse() {
    this.zone.run(() => {
      this._expanded = false;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.bannerData) {
      this.initData();
    }
  }

  private initData() {
    this._expandable = this.bannerData.showCourseBanner && this.bannerData.showNuveiBanner;
    if(!this._expandable)
      this._expanded = false;
    if(this.bannerData.applicationStatus) {
      this.nuveiStatusMessage = {
        'pending': 'Your payment processing application is in review!',
        'rejected': 'Your application for payment processing was rejected',
        'missing_data': 'More information needed',
        'sent_missing_data_to_nuvei': 'The additional information has be sent to Nuvei and is in review!',
        'approved': 'Congratulations! Your payment application was approved by Nuvei',
        'created': 'Complete Nuvei’s application',
      }[this.bannerData.applicationStatus];
      this.nuveiBannerType = {
        'pending': 'warning',
        'rejected': 'error',
        'missing_data': 'error',
        'sent_missing_data_to_nuvei': 'warning',
        'approved': 'success',
        'created': 'success',
      }[this.bannerData.applicationStatus] as BannerComponent['type'];
    } else {
      this.nuveiStatusMessage = 'Start processing payments with Nuvei';
      this.nuveiBannerType = 'success'
    }
  }

  protected dismissBannerClick() {
    this.modalsService.open(ConfirmationDialog, {
      behavior: ModalBehavior.Dialog,
      data: {
        title: 'Hide Banner',
        message: 'Are you sure you want to hide this banner?\n\nYou can still access the credit card processing application and the course anytime from the Settings.',
        actionTitle: 'Yes',
        cancelTitle: 'No',
        action: () => {
          return this.onboardingService.dontShowBannerAgain();
        },
        actionColor: 'primary',
      }
    });
  }

  protected navigateToSettings(tab?: 'Business' | 'Help') {
    if(tab)
      localStorage.setItem(SettingsTabKey, tab);
    this.router.navigate(['/settings']);
  }

  protected viewCourseButtonClick() {
    localStorage.setItem(SettingsHighlightCourseKey, 'TRUE');
    this.onboardingService.dontShowBannerAgain('course')
    this.navigateToSettings('Help');
  }

  protected startNuveiApplicationClick() {
    if(this.utilsService.isMobile()) {
      this.modalsService.open(ConfirmationDialog, {
        behavior: ModalBehavior.Dialog,
        data: {
          title: 'Only Desktop',
          message: 'Applying to Nuvei is only available on PC and tablet devices',
          actionTitle: 'Close',
          action: () => {},
          actionColor: 'primary',
          showCancelButton: false
        }
      });
    } else {
      this.router.navigate(['/payment-application']);
    }
  }

}
